import { render, staticRenderFns } from "./PromotionDetailComponent.vue?vue&type=template&id=b8b4ecfa&scoped=true"
import script from "./PromotionDetailComponent.vue?vue&type=script&lang=js"
export * from "./PromotionDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetailComponent.vue?vue&type=style&index=0&id=b8b4ecfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b4ecfa",
  null
  
)

export default component.exports